export const ELE = {
  // 1:品类/2-颜色/3-图案/4-面料/5-工艺/8-辅料/11-风格/12-性别/13-廓形/20-领型
  1: 'category',
  314: 'category',
  2: 'colorList',
  3: 'texture',
  4: 'fabric',
  5: 'technology',
  8: 'accessories',
  11: 'style',
  12: 'sex',
  13: 'contour',
  20: 'collar',
  31: 'vamp',
  32: 'element',
  33: 'process',
  34: 'sole',
  301: 'shoeDecoration', // 鞋靴品类
  302: 'shoeFabric',
  303: 'shoeTechnology',
  306: 'heelHeight',
  307: 'heelType',
  308: 'upper',
  309: 'toe',
  310: 'shoelace',
  311: 'shoes',
  312: 'tube',
}

export const ELE_TYPE = {
  colorList: '颜色',
  style: '风格',
  texture: '图案',
  technology: '工艺',
  fabric: '面料',
  accessories: '辅料',
  sex: '性别',
  contour: '廓形',
  collar: '领型',
  vamp: '鞋面',
  element: '元素',
  process: '鞋面工艺',
  sole: '跟底',
  shoeDecoration: '鞋靴装饰', // 鞋靴品类
  shoeFabric: '鞋靴面料',
  shoeTechnology: '鞋靴工艺',
  heelHeight: '跟高',
  heelType: '跟型',
  upper: '鞋帮',
  toe: '鞋头',
  shoelace: '鞋带',
  shoes: '开口',
  tube: '筒高',
}

export const SHOP_TYPE = {
  TMALL: '1',
  TAOBAO: '0'
}

export const STYLE_PLAN = {
  ALL: 0,
  YUANCHUANG: 1,
  CAIMAI: 2,
  COOPERATION: 3,
  NUM: 4
}
export const STYLE_PLAN_TEXT = {
  [STYLE_PLAN.ALL]: '不限',
  [STYLE_PLAN.YUANCHUANG]: '原创',
  [STYLE_PLAN.CAIMAI]: '买款',
  [STYLE_PLAN.COOPERATION]: '合作商',
  [STYLE_PLAN.NUM]: '数字款'
}

export const STYLE_TYPE = {
  ALL: 0,
  BASED: 1,
  THEME: 2,
  FIGURE: 3
}

export const STYLE_TYPE_TEXT = {
  [STYLE_TYPE.ALL]: '不限',
  [STYLE_TYPE.BASED]: '基本款',
  [STYLE_TYPE.THEME]: '主题款',
  [STYLE_TYPE.FIGURE]: '形象款'
}

export const SHARE_TYPE = {
  SHARE: 1,
  RECEIVE: 2
}
